<template>
    <div class="container has-text-centered">
      <div class="column is-half is-offset-one-quarter">
        <div
          v-for="inscripcion in inscripciones"
          class="tarjeta"
          :key="inscripcion.id"
          @click="entrar(inscripcion.slug, inscripcion.id)"
        >
          <div class="texto">
            <p>{{ inscripcion.nombre }}</p>
            <span>{{inscripcion.descripcion}}</span>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { detallePreinscripcion } from "../api";
export default {
  data() {
    return {};
  },
 computed: {
    ...mapState([
      "slugInscripcion",
      "slugId"]),
      
    ...mapGetters({
      inscripciones: "getInscripciones",

    })
  },
  methods: {
  ...mapActions(["fetchInscripciones"]),
    entrar(slug,id) {
      this.$store.state.slugInscripcion = slug
      this.$store.state.slugId = id
      this.$router.push({ path: `/registro/${slug}` }) 
    },
  },
  mounted() {
    this.fetchInscripciones();
  }
};
</script>

<style lang="scss" scoped>
.tarjeta {
  height: 150px;
  border-radius: 15px;
  margin: 20px;
  cursor: pointer;
  transition: box-shadow 300ms, transform 300ms;
  box-shadow: 0px 0px 7px -2px rgba(0, 0, 0, 0.5);
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 0px 0px 5px black;
  overflow: hidden;
  background-color: rgb(0, 102, 170);
}

.tarjeta:hover {
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.5);
}

.texto {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  transform: translateY(110px);
  transition: transform 300ms;
  border-radius: 15px;
  padding: 10px;
}

.tarjeta:hover .texto {
  transform: translateY(0px);
}

.tarjeta > .texto > p {
  font-size: 18pt;
}
</style>
